
import { mapState, mapMutations } from "vuex";
import { clone } from "lodash";
export default {
  computed: {
    ...mapState("menu", [
      "menuUploadRawData",
      "menuUploadList",
      "menuUploadFieldMap"
    ])
  },
  props: {
    attributes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dataFields: [],
      categories: []
    };
  },
  mounted() {
    this.dataFields = this.menuUploadList?.length
      ? clone(this.menuUploadFieldMap)
      : new Array(this.menuUploadRawData[0]?.length).fill(null);
  },
  methods: {
    ...mapMutations("menu", [
      "SET_MENU_UPLOAD_LIST",
      "SET_MENU_UPLOAD_FIELD_MAP"
    ]),
    isDisabled(currentItem) {
      return this.dataFields.find((item) => item?.value == currentItem.value);
    },
    setMenuList(newSelection) {
      let list = [],
        obj = {};
      if (newSelection && newSelection.required) {
        const index = this.dataFields.findIndex(
          (el) => el && el.value == newSelection.value
        );
        // on-selection validator
        // const isValid = this.menuUploadRawData.every((el) => !!el[index]);
        // if (!isValid) {
        //   this.$nextTick(() => {
        //     this.$nuxt.$emit(
        //       "show-error-toast",
        //       "Found empty data in required field!"
        //     );
        //     this.$set(this.dataFields, index, null);
        //   });
        //   return;
        // }
      }
      const fieldSelection = this.dataFields
        .map((el, index) => {
          return { index, ...el };
        })
        .filter((el) => !!el.value);

      const categoryRawIndex = fieldSelection.findIndex(
        (el) => el.value === "category-name"
      );
      const isCategorySelection = newSelection?.value === "category-name";
      if (isCategorySelection || categoryRawIndex < 0) this.categories = [];
      const categoryField = fieldSelection[categoryRawIndex];

      this.menuUploadRawData.forEach((item, index) => {
        if (!index) return;

        //Category block
        if (isCategorySelection && item[categoryField?.index]) {
          const isExistingCategory = this.categories.some(
            (el) =>
              typeof el === "string" &&
              el?.toLowerCase()?.trim() ===
                item[categoryField.index]?.toLowerCase()?.trim()
          );
          if (!isExistingCategory) {
            this.categories.push(item[categoryField.index]);
          }
        }

        obj = {};
        obj.id = index;
        fieldSelection.forEach((field) => {
          obj[field.value] = item[field.index];
        });
        list.push(obj);
      });
      this.SET_MENU_UPLOAD_LIST(list);
      this.SET_MENU_UPLOAD_FIELD_MAP(clone(this.dataFields));
    }
  }
};
